<div [class]="paginatorClasses()">
  <div class="v-one-paginator__container">
    <!-- Items per page selector -->
    <div class="v-one-paginator__page-size">
      <label class="v-one-paginator__page-size-label" for="page-size-select">
        {{ 'global.paginator.itemsPerPage' | translate }}
      </label>

      <v-one-input
        class="v-one-paginator__page-size-select"
        [type]="'select'"
        [options]="pageSizeSelectOptions()"
        [dropdownPosition]="'up'"
        [placeholder]="itemsPerPage().toString()"
        (valueChange)="onPageSizeSelectChange($event)"
      />
    </div>

    <!-- Pagination controls -->
    <div class="v-one-paginator__controls">
      <!-- Previous button -->
      <button
        type="button"
        class="v-one-paginator__button v-one-paginator__button--nav"
        [class.v-one-paginator__button--disabled]="isFirstPage()"
        [disabled]="isFirstPage()"
        [attr.aria-label]="'Previous page'"
        (click)="onPreviousClick()"
      >
        <v-one-icon
          [name]="'chevronLeft'"
          [color]="
            isFirstPage() ? 'var(--color-gray-600)' : 'var(--color-gray-900)'
          "
        />
      </button>

      <!-- Page numbers -->
      @for (page of visiblePages(); track $index) {
        @if (isEllipsis(page)) {
          <span class="v-one-paginator__ellipsis">{{ page }}</span>
        } @else {
          <button
            type="button"
            class="v-one-paginator__button v-one-paginator__button--page"
            [class.v-one-paginator__button--active]="isPageActive(page)"
            [attr.aria-label]="'Go to page ' + page"
            [attr.aria-current]="isPageActive(page) ? 'page' : null"
            (click)="onPageClick(page)"
          >
            {{ page }}
          </button>
        }
      }

      <!-- Next button -->
      <button
        type="button"
        class="v-one-paginator__button v-one-paginator__button--nav"
        [class.v-one-paginator__button--disabled]="isLastPage()"
        [disabled]="isLastPage()"
        [attr.aria-label]="'Next page'"
        (click)="onNextClick()"
      >
        <v-one-icon
          [name]="'chevronRight'"
          [color]="
            isLastPage() ? 'var(--color-gray-600)' : 'var(--color-gray-900)'
          "
        />
      </button>
    </div>
  </div>
</div>
